import React, {useState} from "react";
import "./EmailInput.css"

export const EmailInput = ({email, setEmail, handleFinalSubmit}) => {
    const [checkbox1, setCheckbox1] = useState(false);

    return (
        <>
            <h1 className={"extra_text"}>Explorez la voyance par e-mail qui vous est réservée.</h1>
            <input className={"input"} type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Addresse email"/>
            <div className="checkbox-container1">
                <input type="checkbox" id="checkbox1" checked={checkbox1} onChange={() => setCheckbox1(!checkbox1)} />
                <label htmlFor="checkbox1">J'accepte de recevoir les messages & les appels renfermant les prédictions d'Irina.</label>
            </div>
            <button className={!email || !checkbox1 ? "disabled-button" : "button"} disabled={!email || !checkbox1} onClick={handleFinalSubmit}>OBTENEZ LA VOYANCE GRATUITE</button>
        </>
    )
}